import { useState } from 'react';
import css from './Section.module.css';
import Icons from '../../../components/Icons/Icons';

const SectionFAQ = props => {
  const { intl } = props;
  const [activeIndex, setActiveIndex] = useState(0);

  const faqs = [
    {
      questionId: 'SectionFAQ.faq1.question',
      answerId: 'SectionFAQ.faq1.answer',
    },
    {
      questionId: 'SectionFAQ.faq2.question',
      answerId: 'SectionFAQ.faq2.answer',
    },
    {
      questionId: 'SectionFAQ.faq3.question',
      answerId: 'SectionFAQ.faq3.answer',
    },
    {
      questionId: 'SectionFAQ.faq4.question',
      answerId: 'SectionFAQ.faq4.answer',
    },
  ];

  return (
    <div className={css.faqContentWrapper} id="faq">
      <div className={css.fixedWidthContainer}>
        <div className={css.sectionHead}>
          <h2>{intl.formatMessage({ id: 'SectionFAQ.title' })}</h2>
        </div>

        <div className={css.faqSection}>
          {faqs.map((faq, index) => {
            const isOpen = activeIndex === index;
            const contentId = `faq-content-${index}`;

            return (
              <div key={faq.questionId} className={css.faqItem}>
                <button
                  type="button"
                  className={css.faqQuestion}
                  aria-expanded={isOpen}
                  aria-controls={contentId}
                  onClick={() => setActiveIndex(isOpen ? null : index)}
                >
                  <span>{intl.formatMessage({ id: faq.questionId })}</span>
                  <span className={css.faqIcon} aria-hidden="true">
                    <Icons name={isOpen ? 'faqOpenIcon' : 'faqCloseIcon'} />
                  </span>
                </button>

                {isOpen ? (
                  <div id={contentId} className={css.faqAnswer}>
                    {intl.formatMessage({ id: faq.answerId })}
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SectionFAQ;
